import { useTheme } from "@emotion/react";
import {
  Add,
  ArrowBack,
  EditOutlined,
  HistoryOutlined,
  ManageAccounts,
  MoreVertOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Avatar,
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import EditOsComponent from "../editOsComponent";
import useStyles from "./styles";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import CopyButton from "../shared/copyButton";
import InfoField from "../shared/infoField";

export default function OrdemServiceComponent(params) {
  const {
    ticketDetails,
    setTicketDetails = () => {},
    isEdit = false,
    setOpenEditOS = () => {},
    openEditOS = false,
    setOpenNewOs = () => {},
    openNewOs = false,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [tecnicosSelecionados, setTecnicosSelecionados] = useState([]);
  const [disponibilidadeSelecionada, setDisponibilidadeSelecionada] = useState(
    [],
  );
  const [tipoAgendamento, setTipoAgendamento] = useState("manual");
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [dateEdited, setDateEdited] = useState(null);
  const [error, setError] = useState(false);
  const [loadingCreateOs, setLoadingCreateOs] = useState(false);
  const [paramsEditOs, setParamsEditOs] = useState(null);
  const [loadingParams, setLoadingParams] = useState(false);
  const [osHistorico, setOsHistorico] = useState([]);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [tecnicos, setTecnicos] = useState([]);
  const [tipoOs, setTipoOs] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [disponibilidade, setDisponibilidade] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [paramsAberturaOs, setParamsAberturaOs] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const [dataProgramada, setDataProgramada] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setTecnicosSelecionados(item?.tecnicos || []);
    setDisponibilidadeSelecionada(item?.disponibilidade || []);
    setParamsEditOs({
      numero_ordem_servico: item?.numero_ordem_servico || null,
      idOs: item?.id || null,
      agenda: {
        id: item?.agenda?.id_agenda || null,
        descricao: item?.agenda?.descricao || null,
      },
      descricaoAbertura: item?.descricao_servico,
      disponibilidade: item?.disponibilidade || null,
      prioridade: {
        id_prioridade: item?.id_prioridade || null,
      },
      statusOs: item?.status_fechamento || null,
      tecnicos: item?.tecnicos || [],
      tipoOs: {
        id: item?.id_tipo_ordem_servico || null,
      },
    });
    setDataProgramada({
      data_inicio_programado: item?.data_inicio_programado || null,
      data_termino_programado: item?.data_termino_programado || null,
    });
  };
  const handleEditOS = () => {
    setOpenEditOS(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (openNewOs === true || openEditOS === true) {
      getParamsNewOS();
    }
  }, [openNewOs, openEditOS]);

  const getParamsNewOS = async () => {
    setLoadingParams(true);
    try {
      const response = await api.get("/interno/find/paramsNewOs");

      setTecnicos(response?.data?.tecnicos || []);
      setTipoOs(response?.data?.tipoOs || []);
      setPrioridades(response?.data?.prioridade || []);
      setDisponibilidade(response?.data?.disponibilidade || []);
      setAgenda(response?.data?.agenda || []);
      setStatusOs(response?.data?.statusOs || []);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };

  /*   const getAgendaAutomatica = async (data) => {


    try{

    }catch(error){
      console.error("Erro ao buscar agenda automática:", error);
      setSnackbar({
        severity: "error",
        children: "Erro ao buscar agenda automática",
      });

    }finally{

    }
  }
 */
  const createOs = async () => {
    if (
      !paramsAberturaOs?.tipoOs?.id ||
      !paramsAberturaOs?.prioridade?.id_prioridade ||
      paramsAberturaOs?.disponibilidade?.length === 0 ||
      !paramsAberturaOs?.disponibilidade ||
      !paramsAberturaOs?.agenda?.id ||
      !paramsAberturaOs?.statusOs ||
      !paramsAberturaOs?.data_inicio_programado ||
      (dateEdited &&
        paramsAberturaOs?.data_inicio_programado &&
        paramsAberturaOs?.hora_inicio_programado &&
        dayjs(
          `${paramsAberturaOs.data_inicio_programado} ${paramsAberturaOs.hora_inicio_programado}`,
        ).isBefore(dayjs())) ||
      !paramsAberturaOs?.data_termino_programado ||
      paramsAberturaOs?.tecnicos?.length === 0 ||
      !paramsAberturaOs?.tecnicos ||
      !paramsAberturaOs?.descricaoAbertura?.trim()
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setLoadingCreateOs(true);
    try {
      const response = await api.post("/interno/create/os", {
        dataOs: paramsAberturaOs,
        idAtendimento: ticketDetails?.id_atendimento,
        idClienteServico: ticketDetails?.cliente_servico?.id_cliente_servico,
        tipoAgendamento: tipoAgendamento,
      });

      setTicketDetails(response?.data);
      setSnackbar({
        severity: "success",
        children: "OS criada com sucesso",
      });
      closeNewOs();
    } catch (error) {
      console.error("Erro ao criar OS:", error);
      setSnackbar({
        severity: "error",
        children: error?.response?.data?.message,
      });
    } finally {
      setLoadingCreateOs(false);
    }
  };
  const editOs = async () => {
    if (
      !paramsEditOs?.tipoOs?.id ||
      !paramsEditOs?.prioridade?.id_prioridade ||
      paramsEditOs?.disponibilidade?.length === 0 ||
      !paramsEditOs?.disponibilidade ||
      !paramsEditOs?.agenda?.id ||
      !paramsEditOs?.statusOs ||
      !paramsEditOs?.data_inicio_programado ||
      (dateEdited &&
        paramsEditOs?.data_inicio_programado &&
        paramsEditOs?.hora_inicio_programado &&
        dayjs(
          `${paramsEditOs.data_inicio_programado} ${paramsEditOs.hora_inicio_programado}`,
        ).isBefore(dayjs())) ||
      !paramsEditOs?.data_termino_programado ||
      paramsEditOs?.tecnicos?.length === 0 ||
      !paramsEditOs?.tecnicos ||
      !paramsEditOs?.descricaoAbertura?.trim()
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setLoadingCreateOs(true);
    try {
      const response = await api.post("/interno/edit/os", {
        dataOs: paramsEditOs,
        idOs: paramsEditOs?.idOs,
        idAtendimento: ticketDetails?.id_atendimento,
      });
      setTicketDetails(response?.data);
      setSnackbar({
        severity: "success",
        children: "OS editada com sucesso",
      });
    } catch (error) {
      console.error("Erro ao editar OS:", error);
      setSnackbar({
        severity: "error",
        children: "Erro ao editar OS",
      });
    } finally {
      setLoadingCreateOs(false);
      closeEditOs();
    }
  };

  const getOsHistorico = async () => {
    setOpenHistorico(true);
    setAnchorEl(null);
    try {
      const response = await api.post("/interno/find/historicoOs", {
        osId: paramsEditOs?.idOs,
      });
      setOsHistorico(response?.data);

      /*   setHistorico(response?.data); */
    } catch (error) {
      console.error("Erro ao buscar osHistorico:", error);
    }
  };
  function formatDescricao(mensagem) {
    return (
      <Box sx={{ padding: 1 }}>
        {mensagem?.split("\n\n")?.map((paragraph, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap", // mantém quebras de linha originais
              overflowWrap: "break-word", // quebra palavras longas
              wordBreak: "break-word", // reforça quebra em palavras muito longas
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    );
  }

  const closeEditOs = () => {
    setDateEdited(false);
    setOpenEditOS(false);
    setTecnicosSelecionados([]);
    setDisponibilidadeSelecionada([]);

    setParamsEditOs(null);
    setError(false);
  };

  const closeNewOs = () => {
    setDateEdited(false);
    setOpenNewOs(false);
    setConfirmacaoSaidaPagina(false);
    setTecnicosSelecionados([]);
    setDisponibilidadeSelecionada([]);

    setParamsAberturaOs(null);
    setError(false);
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  function formatarNome(nome) {
    if (!nome) return "";

    return nome
      .toLowerCase() // tudo minúsculo
      .replace(/_/g, " ") // troca underscore por espaço
      .replace(/\s+/g, " ") // remove espaços extras
      .trim() // remove espaços no início/fim
      .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase()); // primeira letra de cada palavra maiúscula
  }

  const prioridade = {
    Baixa: theme.palette.colors.green.medium,
    Normal: theme.palette.colors.blue.medium,
    Alta: theme.palette.colors.orange.dark,
    Urgente: theme.palette.colors.red.medium,
  };
  const statusOrdemServico = {
    aberto: theme.palette.colors.blue.dark,
    em_andamento: theme.palette.colors.orange.dark,
    pendente: theme.palette.colors.pink.dark,
    finalizado: theme.palette.colors.green.dark,
    cancelado: theme.palette.colors.gray.dark,
    aguardando_agendamento: theme.palette.colors.gray.dark,
  };
  return (
    <Box sx={{ height: "85%", overflowY: "auto" }}>
      {openNewOs ? (
        <Box>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Nova OS
            </Typography>
          </Box>

          <Box
            sx={{
              ...styles.containerBodyModal,
            }}
          >
            <EditOsComponent
              setDateEdited={setDateEdited}
              loadingParams={loadingParams}
              loadingCreateOs={loadingCreateOs}
              tipoOs={tipoOs}
              error={error}
              prioridades={prioridades}
              disponibilidade={disponibilidade}
              statusOs={statusOs}
              setParamsAberturaOs={setParamsAberturaOs}
              paramsAberturaOs={paramsAberturaOs}
              agenda={agenda}
              setDisponibilidadeSelecionada={setDisponibilidadeSelecionada}
              setTecnicosSelecionados={setTecnicosSelecionados}
              tecnicosSelecionados={tecnicosSelecionados}
              tecnicos={tecnicos}
              disponibilidadeSelecionada={disponibilidadeSelecionada}
              editOs={false}
              idClienteServico={
                ticketDetails?.cliente_servico?.id_cliente_servico
              }
              tipoAgendamento={tipoAgendamento}
              setTipoAgendamento={setTipoAgendamento}
            />
          </Box>
          <Box sx={styles.containerActions}>
            <Button
              disabled={loadingCreateOs}
              onClick={() => setConfirmacaoSaidaPagina(true)}
              size="small"
              variant="outlined"
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={loadingCreateOs}
              onClick={() => createOs()}
              size="small"
              variant="contained"
            >
              Salvar
            </LoadingButton>
          </Box>
        </Box>
      ) : openEditOS ? (
        <Box>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Editar OS - (Número OS: {paramsEditOs?.numero_ordem_servico})
            </Typography>
          </Box>
          <Box
            sx={{
              ...styles.containerBodyModal,
            }}
          >
            <EditOsComponent
              setDateEdited={setDateEdited}
              loadingParams={loadingParams}
              loadingCreateOs={loadingCreateOs}
              tipoOs={tipoOs}
              error={error}
              prioridades={prioridades}
              disponibilidade={disponibilidade}
              statusOs={statusOs}
              setParamsAberturaOs={setParamsEditOs}
              paramsAberturaOs={paramsEditOs}
              agenda={agenda}
              setDisponibilidadeSelecionada={setDisponibilidadeSelecionada}
              setTecnicosSelecionados={setTecnicosSelecionados}
              tecnicosSelecionados={tecnicosSelecionados}
              tecnicos={tecnicos}
              disponibilidadeSelecionada={disponibilidadeSelecionada}
              dataInicioProgramada={dataProgramada?.data_inicio_programado}
              dataTerminoProgramada={dataProgramada?.data_termino_programado}
            />
          </Box>
          <Box sx={styles.containerActions}>
            <Button
              disabled={loadingCreateOs}
              onClick={() => closeEditOs()}
              size="small"
              variant="outlined"
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={loadingCreateOs}
              onClick={() => editOs()}
              size="small"
              variant="contained"
            >
              Salvar
            </LoadingButton>
          </Box>
        </Box>
      ) : openHistorico ? (
        <>
          <Box sx={styles.containerHistorico}>
            <Tooltip title={"Voltar"}>
              <IconButton
                size="small"
                onClick={() => {
                  setOpenHistorico(false);
                  setOsHistorico([]);
                }}
                variant="outlined"
              >
                <ArrowBack fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography sx={styles.titleDescription}>
              {/* <HistoryOutlined sx={{ fontSize: "18px" }} /> */}
              Histórico - (Número OS: {paramsEditOs?.numero_ordem_servico})
            </Typography>
          </Box>
          <Paper sx={styles.paperHistorico} variant="outlined">
            <Box sx={styles.boxHistorico}>
              {osHistorico?.map((item, index) => (
                <Paper
                  sx={{
                    ...styles.containerPaperMensagem,
                  }}
                  elevation={0}
                  variant="outlined"
                >
                  <Box sx={styles.bodyMensagem}>
                    <Box sx={styles.containerAvatar}>
                      <Avatar
                        src={item?.usuario?.link}
                        alt={item?.usuario?.nome}
                      />

                      <Box sx={{}}>
                        <Typography sx={styles.nameUser}>
                          {item?.usuario?.nome}
                        </Typography>
                        <Typography sx={{ fontSize: "12px" }}>
                          {dayjs(item?.data_cadastro).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Divider />{" "}
                  <Box sx={{ padding: 2 }}>
                    <Typography sx={styles.textMensagem}>
                      {item?.descricao}
                    </Typography>{" "}
                  </Box>
                </Paper>
              ))}
            </Box>
          </Paper>
        </>
      ) : (
        <>
          <Box sx={styles.boxEdit}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Ordem de serviço
            </Typography>
            {ticketDetails?.status?.id === 1 &&
              isEdit &&
              !ticketDetails?.configTicket && (
                <Button
                  onClick={() => setOpenNewOs(true)}
                  endIcon={<Add />}
                  variant="outlined"
                  size="small"
                >
                  Abrir OS
                </Button>
              )}
          </Box>
          <Box sx={styles.containerBodyModal}>
            <Box sx={styles.boxBodyModal}>
              <Paper
                variant="outlined"
                elevation={0}
                sx={styles.containerPaperModal}
              >
                <Box sx={styles.listaOs}>
                  {ticketDetails?.ordem_servico?.map((ordemService, index) => (
                    <Paper
                      key={ordemService?.numero_ordem_servico || index}
                      sx={styles.containerPaper}
                      variant="outlined"
                      elevation={0}
                    >
                      {/* Cabeçalho do cartão: o número da OS e o status são o
                          que identifica a ordem, então saem da grade de campos
                          e ganham a primeira linha. */}
                      <Box sx={styles.cardHeader}>
                        <Box sx={styles.cardHeaderIdentificacao}>
                          <Typography sx={styles.cardNumeroOs}>
                            OS {ordemService?.numero_ordem_servico}
                          </Typography>
                          <CopyButton
                            value={ordemService?.numero_ordem_servico}
                            setSnackbar={setSnackbar}
                            title="Copiar número da OS"
                            mensagem="Número da OS copiado!"
                          />
                          <Tooltip
                            title={
                              ordemService?.data_inicio_executado &&
                              !ordemService?.data_termino_executado
                                ? `Em execução desde ${dayjs(ordemService.data_inicio_executado).format("DD/MM/YYYY HH:mm")}`
                                : formatarNome(ordemService?.status_fechamento)
                            }
                          >
                            <Chip
                              size="small"
                              sx={{
                                ...styles.chip,
                                backgroundColor:
                                  statusOrdemServico[
                                    ordemService?.status_fechamento
                                  ],
                              }}
                              label={
                                ordemService?.data_inicio_executado &&
                                !ordemService?.data_termino_executado
                                  ? `Em execução`
                                  : formatarNome(
                                      ordemService?.status_fechamento,
                                    )
                              }
                            />
                          </Tooltip>
                        </Box>

                        {!ticketDetails?.configTicket && (
                          <IconButton
                            onClick={(e) => handleClick(e, ordemService)}
                            size="small"
                            sx={styles.cardMenuButton}
                          >
                            <MoreVertOutlined fontSize="small" />
                          </IconButton>
                        )}
                      </Box>

                      <Divider />

                      <Box sx={styles.cardSecao}>
                        <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Agenda"
                              value={ordemService?.agenda?.descricao}
                              tooltip={ordemService?.agenda?.descricao}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField label="Disponibilidade">
                              {ordemService?.disponibilidade_str ? (
                                <Tooltip
                                  title={ordemService?.disponibilidade_str}
                                >
                                  <Chip
                                    size="small"
                                    sx={{
                                      ...styles.chip,
                                      backgroundColor:
                                        theme.palette.colors.purple.medium,
                                    }}
                                    label={ordemService?.disponibilidade_str}
                                  />
                                </Tooltip>
                              ) : null}
                            </InfoField>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField label="Prioridade">
                              {ordemService?.prioridade ? (
                                <Tooltip title={ordemService?.prioridade}>
                                  <Chip
                                    size="small"
                                    sx={{
                                      ...styles.chip,
                                      backgroundColor:
                                        prioridade[ordemService?.prioridade],
                                    }}
                                    label={ordemService?.prioridade}
                                  />
                                </Tooltip>
                              ) : null}
                            </InfoField>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField label="Tipo de O.S.">
                              {ordemService?.tipo_ordem_servico ? (
                                <Tooltip
                                  title={ordemService?.tipo_ordem_servico}
                                >
                                  <Chip
                                    size="small"
                                    sx={{
                                      ...styles.chip,
                                      backgroundColor:
                                        theme.palette.colors.pink.medium,
                                    }}
                                    label={ordemService?.tipo_ordem_servico}
                                  />
                                </Tooltip>
                              ) : null}
                            </InfoField>
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Aberto em"
                              value={
                                ordemService?.data_cadastro_timestamp
                                  ? dayjs(
                                      ordemService?.data_cadastro_timestamp,
                                    )?.format("DD/MM/YY HH:mm")
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Data programada"
                              value={
                                ordemService?.data_inicio_programado
                                  ? dayjs(
                                      ordemService?.data_inicio_programado,
                                    ).format("DD/MM/YY HH:mm")
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <InfoField
                              label="Data término"
                              value={
                                ordemService?.data_termino_programado
                                  ? dayjs(
                                      ordemService?.data_termino_programado,
                                    ).format("DD/MM/YY HH:mm")
                                  : ""
                              }
                            />
                          </Grid>
                          {ordemService?.data_termino_executado_timestamp && (
                            <Grid item xs={12} sm={6} lg={4}>
                              <InfoField
                                label="Finalizado em"
                                value={dayjs(
                                  ordemService?.data_termino_executado_timestamp,
                                )?.format("DD/MM/YY HH:mm")}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Box>

                      <Divider />

                      <Box sx={styles.cardSecao}>
                        <Box sx={styles.cardSecaoHeader}>
                          <Typography sx={styles.cardSecaoTitulo}>
                            Descrição do serviço
                          </Typography>
                          {ordemService?.descricao_servico && (
                            <CopyButton
                              value={ordemService?.descricao_servico}
                              setSnackbar={setSnackbar}
                              title="Copiar descrição do serviço"
                              mensagem="Descrição do serviço copiada!"
                            />
                          )}
                        </Box>
                        {ordemService?.descricao_servico ? (
                          formatDescricao(ordemService?.descricao_servico)
                        ) : (
                          <Typography sx={styles.textoVazio}>
                            Nenhuma descrição informada.
                          </Typography>
                        )}
                      </Box>

                      {ordemService?.descricao_fechamento && (
                        <>
                          <Divider />
                          <Box sx={styles.cardSecao}>
                            <Box sx={styles.cardSecaoHeader}>
                              <Typography sx={styles.cardSecaoTitulo}>
                                Descrição de fechamento
                              </Typography>
                              <CopyButton
                                value={ordemService?.descricao_fechamento}
                                setSnackbar={setSnackbar}
                                title="Copiar descrição de fechamento"
                                mensagem="Descrição de fechamento copiada!"
                              />
                            </Box>
                            {formatDescricao(
                              ordemService?.descricao_fechamento,
                            )}
                          </Box>
                        </>
                      )}

                      {ordemService?.tecnicos?.length > 0 && (
                        <>
                          <Divider />
                          <Box sx={styles.cardSecao}>
                            <Typography sx={styles.cardSecaoTitulo}>
                              Técnicos
                            </Typography>
                            <Box sx={styles.containerTecnicos}>
                              {ordemService?.tecnicos?.map((tecnico) => (
                                <Box
                                  key={tecnico?.id || tecnico?.name}
                                  sx={styles.boxDataTecnico}
                                >
                                  <Avatar
                                    src={tecnico?.imagem}
                                    alt={tecnico?.name}
                                    sx={styles.avatarTecnico}
                                  />
                                  <Typography sx={styles.nomeTecnico}>
                                    {tecnico?.name}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        </>
                      )}

                      {ordemService?.anexos?.length > 0 && (
                        <>
                          <Divider />
                          <Box sx={styles.cardSecao}>
                            <Typography sx={styles.cardSecaoTitulo}>
                              Anexos ({ordemService?.anexos?.length})
                            </Typography>
                            <Box sx={styles.containerAnexos}>
                              {ordemService?.anexos?.map((anexo) => (
                                <Paper
                                  key={anexo.id_arquivo_upload}
                                  elevation={2}
                                  sx={styles.paperAnexo}
                                >
                                  <a
                                    href={anexo.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={anexo.link_thumb || anexo.link}
                                      alt={anexo.nome}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition:
                                          "transform 0.3s ease-in-out",
                                      }}
                                    />
                                  </a>
                                </Paper>
                              ))}
                            </Box>
                          </Box>
                        </>
                      )}
                    </Paper>
                  ))}
                </Box>
              </Paper>
            </Box>
          </Box>
        </>
      )}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem
          disabled={paramsEditOs?.statusOs === "finalizado"}
          onClick={handleEditOS}
        >
          <ListItemIcon>
            <EditOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem onClick={getOsHistorico}>
          <ListItemIcon>
            <HistoryOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Histórico</ListItemText>
        </MenuItem>
      </Menu>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={closeNewOs}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </Box>
  );
}
